/* Copyright (c) 2023  joanribalta@elmolideponent.com */

class Log
{
    static init(consoleDebug = true, serverDebug = true)
    {
        this._browserConsoleDebug = consoleDebug;
        this._serverDebug = serverDebug;
        window.onerror = (message) =>
        {
            this.print("OnError: " + message);
            return false;
        };

        // this.print("test");
    }

    static print(message)
    {
        if (this._browserConsoleDebug === true)
        {
            console.log(message);
        }

        if (this._serverDebug === true)
        {
            fetch('/log', {
                method: "POST",
                body: 'message=' + encodeURIComponent(message),
                headers: {"Content-type": "application/x-www-form-urlencoded; charset=UTF-8"}
            });
        }
    }
}

export { Log };

